<template>
  <div class="predefine" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div class="predefine-card" >
          <v-row class="relative">
            <v-col cols="8">
              <v-text-field
                :label="$t('priceNotReq')"
                v-model="price"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <div class="choose-select">
                <v-select
                  :items="currency_items"
                  :label="$t('select')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_currency"
                >
                </v-select>

              </div>
            </v-col>

          </v-row>
<v-row>
  <v-col cols="8">
    <v-text-field
      label="زمان حدودی تعمیر (روز)"
      v-model="tamir_days"
      type="number"
      outlined
    ></v-text-field>
  </v-col>

</v-row>
          <div v-for="item in pre_defined_items">

            <v-row class="checkbox-row">
              <v-col v-if="item.PredefineTypeId == 1">
                <label>{{item.Text}}</label>

              </v-col>

              <v-col v-if="item.PredefineTypeId == 1">
                <v-checkbox
                  v-model="item.IsChecked"
                  :value="item.IsChecked"
                />
              </v-col>

              <v-col v-if="item.PredefineTypeId == 2">
                <v-text-field
                  v-if="item.PredefineTypeId == 2"
                  v-model="item.Value"
                  :label="item.Text"
                  value="false"
                  outlined
                />
              </v-col>

            </v-row>

          </div>

          <div class="relative device-pass">
            <v-text-field
              :label="$t('devicePassword')"
              v-model="device_password"
              outlined
            ></v-text-field>
          </div>
        </div>
        <v-row>

          <v-btn color="primary" style="border-radius: 0px;" class="enter-btn"  v-on:click="go_to_details()">{{ $t('add_information') }}</v-btn>

        </v-row>
        <div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        tamir_days:'',
        errors: [],
        currency_items: [],
        selected_currency: 0,
        price: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],

        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {

    },
mounted () {
      this.get_currencies()
      this.get_branch_permission()
      this.get_predifined()
    },
    methods: {
      go_to_details () {
        // var PassingData = {'on_site_service':OnSite}
        // if (this.fullName != '') {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.device_password = this.device_password
        passing_data.price = this.price
        passing_data.currency = this.selected_currency
        passing_data.branch_id = this.branch_id
        passing_data.tamir_days = this.tamir_days
        // passing_data.device_serial_number = this.device_serial_number;
        passing_data.pre_defined = JSON.stringify(this.pre_defined_items)
        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ name: 'request_detail', params: {} })
        // } else {
        //   bus.$emit('show_dialog', ["خطا", "لطفا شماره مشتری را وارد کنید"])
        //
        // }
      },
      get_currencies () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCurrencies', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.Currencies.forEach(function (number) {
                if (number.CurrencyName == self.$t('currencyName')) {
                  self.selected_currency = number.CurrencyId
                }
                var obj = { label: number.CurrencyName, value: number.CurrencyId }
                self.currency_items.push(obj)
              })
              // response.data.parties.forEach(function(item) {
              //   console.log("sdsd"+item)
              //
              // });
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_branch_permission () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          Role: 'BranchDefinition',
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
             this.branch_id = response.data.UserBranchId
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_predifined () {
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var user_id = passing_data.UserId
        var typeId = passing_data.cat_id
        var catId = passing_data.group_id
        var subcatId = passing_data.sub_group_id
        var brandId = passing_data.brand_id
        var DeviceModel = passing_data.device_model

        const send_data = {
          TypeId: typeId,
          CatId: catId,
          GroupId: subcatId,
          BrandId: brandId,
          Model: DeviceModel,
          Phone: DeviceModel,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PredefinedText', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
self.pre_defined_items = response.data.PredefinedList
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
